import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { vars } from '@/styles/styleVars'
import { Status } from './types/LfProgressBarTypes'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'LfSimpleProgressBarComponent',
  props: {
  text: {
    type: String,
    required: false
  },
  status: {
    type: String as PropType<Status>,
    required: false,
    default: Status.LOADING
  },
  icon: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props;



// COMPUTED
const computedIndeterminate = computed(() => props.status === Status.LOADING)

const computedBackgroundColor = computed(() => {
  switch (props.status) {
    case Status.LOADED:
      return vars.progress_bar_success
    case Status.ERROR:
      return vars.progress_bar_error
    default:
      return vars.progress_bar_default_color
  }
})


return { __sfc: true,props, computedIndeterminate, computedBackgroundColor, vars }
}

})